import React from "react";
import Report from "../components/Report";
import Table from "../../../components/TableX";
import { useLazyQuery, useQuery, API } from "../../../api";

export default function AgingDetails() {
  const [getReport, { data, loading }] = useLazyQuery(API.GET_AGING_DETAILS, {
    fetchPolicy: "network-only",
  });
  const { data: routes } = useQuery(API.GET_ROUTES);

  const routeOptions = React.useMemo(
    () => routes?.result?.map((t) => ({ title: t?.name, value: t?._id })),
    [routes]
  );

  const [filters, setFilters] = React.useState({ route: "" });

  React.useEffect(() => {
    getReport({ data: filters });
    // eslint-disable-next-line
  }, [filters]);

  const columns = [
    {
      name: "date",
      label: "Date",
      options: { align: "center", date: true },
    },
    {
      name: "invoiceNo",
      label: "Invoice No",
      options: { align: "center" },
    },
    {
      name: "customer",
      label: "Customer",
      options: { align: "left", width: 400 },
    },
    {
      name: "age",
      label: "Age (Days)",
      options: { align: "center" },
    },
    {
      name: "netTotal",
      label: "Invoice Amount",
      options: { align: "right", money: true, showTotal: true },
    },
    {
      name: "dueAmount",
      label: "Balance Due",
      options: { align: "right", money: true, showTotal: true },
    },
  ];

  return (
    <Report
      title="Aging Details"
      data={data}
      columns={columns}
      filters={[
        {
          type: "autocomplete",
          name: "route",
          label: "Route",
          options: routeOptions,
          value: filters?.route,
        },
      ]}
      onFiltersChange={(e) => setFilters((x) => ({ ...x, ...e }))}
    >
      <Table data={data} columns={columns} showTotals isLoading={loading} />
    </Report>
  );
}
